import {useCallback, useRef, useState} from 'react';

import {useApi} from '~/modules/api';
import {downloadBlob} from '~/modules/utils';
import {useAuth} from '~/store/hooks';

export function useAskStats() {
  // TODO: prompt for PIN
  const {onSetShowPinConfirm} = useAuth();
  const once = useRef(false);

  const [downloadingAskStatsStatus, setDownloadingAskStatsStatus] = useState<
    'none' | 'requesting' | 'success' | 'error'
  >('none');
  const [downloadingAskStatsErrorMsg, setDownloadingAskStatsErrorMsg] =
    useState('');

  const api = useApi();

  const downloadAskStatsCSV = useCallback(async () => {
    try {
      if (!once.current) {
        onSetShowPinConfirm({showPinConfirm: true});
        once.current = true;
        return;
      }
      if (
        downloadingAskStatsStatus === 'none' ||
        downloadingAskStatsStatus === 'error'
      ) {
        setDownloadingAskStatsStatus('requesting');
        setDownloadingAskStatsErrorMsg('');
        const {data} = await api.fetch({url: '/askStats'});
        if (data.status !== 'success') {
          throw new Error(data.errorMessage);
        }
        downloadBlob(data.data.csv, 'askStats.csv', 'text/csv;charset=utf-8;');
        setDownloadingAskStatsStatus('success');
        once.current = false;
      }
    } catch (error) {
      setDownloadingAskStatsStatus('error');
      if (error instanceof Error) {
        setDownloadingAskStatsErrorMsg(error.message);
      }
    }
  }, [api, downloadingAskStatsStatus, onSetShowPinConfirm]);

  return {
    downloadingAskStatsErrorMsg,
    downloadingAskStatsStatus,
    downloadAskStatsCSV,
  };
}
